/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
import type { mapSpacesWithParams$ref } from "./mapSpacesWithParams.graphql";
export type SearchSpaceParams = {|
  lang?: ?string,
  front?: ?boolean,
  boundaries?: ?$ReadOnlyArray<?$ReadOnlyArray<?number>>,
  category?: ?string,
  pattern?: ?$ReadOnlyArray<?string>,
  patternkeywords?: ?$ReadOnlyArray<?string>,
  dates?: ?SearchSpaceParamsDate,
  byHour?: ?boolean,
  riders?: ?$ReadOnlyArray<?number>,
  caracteristics?: ?$ReadOnlyArray<?string>,
  disposition?: ?$ReadOnlyArray<?string>,
  price?: ?SearchSpaceParamsRange,
  formuleprice?: ?SearchSpaceParamsRange,
  hof?: ?$ReadOnlyArray<?string>,
  utilities?: ?$ReadOnlyArray<?string>,
  equipments?: ?$ReadOnlyArray<?string>,
  subspaces?: ?$ReadOnlyArray<?string>,
  types?: ?$ReadOnlyArray<?string>,
  highceiling?: ?SearchSpaceParamsRange,
  floor?: ?$ReadOnlyArray<?string>,
  surface?: ?SearchSpaceParamsRange,
  vues?: ?$ReadOnlyArray<?string>,
  ambiences?: ?$ReadOnlyArray<?string>,
  extrasincluded?: ?$ReadOnlyArray<?string>,
  extrasservices?: ?$ReadOnlyArray<?string>,
  limit?: ?SearchSpaceParamsRange,
  locationOnly?: ?boolean,
  zoom?: ?number,
  circle?: ?Circle,
  hofRate?: ?string,
|};
export type SearchSpaceParamsDate = {|
  values?: ?$ReadOnlyArray<?SearchSpaceParamsDValues>,
  flexibility?: ?$ReadOnlyArray<?number>,
|};
export type SearchSpaceParamsDValues = {|
  date?: ?string,
  period?: ?number,
  hours?: ?number,
|};
export type SearchSpaceParamsRange = {|
  from?: ?number,
  to?: ?number,
|};
export type Circle = {|
  latlng?: ?$ReadOnlyArray<?number>,
  radius?: ?number,
|};
export type mapSpaceWithParamsQueryVariables = {|
  params?: ?SearchSpaceParams,
  corpoRef?: ?string,
|};
export type mapSpaceWithParamsQueryResponse = {|
  +$fragmentRefs: mapSpacesWithParams$ref
|};
export type mapSpaceWithParamsQuery = {|
  variables: mapSpaceWithParamsQueryVariables,
  response: mapSpaceWithParamsQueryResponse,
|};
*/


/*
query mapSpaceWithParamsQuery(
  $params: SearchSpaceParams
  $corpoRef: String
) {
  ...mapSpacesWithParams_2VKVxp
}

fragment mapSpacesWithParams_2VKVxp on Query {
  results: searchSpaceByParams(params: $params) {
    spaces {
      id
      searchMap {
        location
        slug
        place_id
      }
      dataByCategory(category: "production") {
        price {
          amount_excl_tax
        }
        corpoPrice: price(input: {corpoRef: $corpoRef}) {
          amount_excl_tax
        }
      }
    }
    byCity {
      id
      location
      spacesCount
    }
    byDistrict {
      id
      location
      spacesCount
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "corpoRef"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "params"
},
v2 = {
  "kind": "Variable",
  "name": "corpoRef",
  "variableName": "corpoRef"
},
v3 = {
  "kind": "Variable",
  "name": "params",
  "variableName": "params"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount_excl_tax",
    "storageKey": null
  }
],
v7 = [
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "spacesCount",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "mapSpaceWithParamsQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "mapSpacesWithParams"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "mapSpaceWithParamsQuery",
    "selections": [
      {
        "alias": "results",
        "args": [
          (v3/*: any*/)
        ],
        "concreteType": "SearchSpacesForMap",
        "kind": "LinkedField",
        "name": "searchSpaceByParams",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SearchSpaceLocation",
                "kind": "LinkedField",
                "name": "searchMap",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "place_id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "category",
                    "value": "production"
                  }
                ],
                "concreteType": "DataByCategory",
                "kind": "LinkedField",
                "name": "dataByCategory",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Price",
                    "kind": "LinkedField",
                    "name": "price",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "corpoPrice",
                    "args": [
                      {
                        "fields": [
                          (v2/*: any*/)
                        ],
                        "kind": "ObjectValue",
                        "name": "input"
                      }
                    ],
                    "concreteType": "Price",
                    "kind": "LinkedField",
                    "name": "price",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": "dataByCategory(category:\"production\")"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SearchLocation",
            "kind": "LinkedField",
            "name": "byCity",
            "plural": true,
            "selections": (v7/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SearchLocation",
            "kind": "LinkedField",
            "name": "byDistrict",
            "plural": true,
            "selections": (v7/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7cb64290c3c4cd69b10e99d697ceb3e9",
    "id": null,
    "metadata": {},
    "name": "mapSpaceWithParamsQuery",
    "operationKind": "query",
    "text": "query mapSpaceWithParamsQuery(\n  $params: SearchSpaceParams\n  $corpoRef: String\n) {\n  ...mapSpacesWithParams_2VKVxp\n}\n\nfragment mapSpacesWithParams_2VKVxp on Query {\n  results: searchSpaceByParams(params: $params) {\n    spaces {\n      id\n      searchMap {\n        location\n        slug\n        place_id\n      }\n      dataByCategory(category: \"production\") {\n        price {\n          amount_excl_tax\n        }\n        corpoPrice: price(input: {corpoRef: $corpoRef}) {\n          amount_excl_tax\n        }\n      }\n    }\n    byCity {\n      id\n      location\n      spacesCount\n    }\n    byDistrict {\n      id\n      location\n      spacesCount\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7591cfca5dcfba589b072c1c5b42bd71';

module.exports = node;
